import * as React from 'react';
import BigCalendar from 'react-big-calendar';
import * as moment from 'moment';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Subscriber, Broadcast } from 'react-broadcast';
import { Popover } from 'antd';
// import { DatePicker as AntdDatePicker } from 'antd';

require('moment/locale/cs');
moment.locale('cs');

import {
  RendererComponentProps,
  ContextObserver,
  ResourceCollection,
  // Renderer,
  evaluate,
  renderTemplate,
  translate,
  Renderer
} from '../../../../webana';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import withDragDropContext, { getDragCalendar } from '../../../../utils/withDragDropContext';
// import 'globalize/lib/cultures/globalize.culture.cz';

const DragAndDropCalendar = getDragCalendar();

interface CalendarConfig {
  date?: string;
  onNavigate?: string;
  tooltipContent?: string;
  view?: string;
  onView?: string;
  onSelectEvent?: string;
  onSelectSlot?: string;
  onEventDrop?: string;
  resource: string;
  height?: number;
  titleAccessor?: string;
  startAccessor?: string;
  endAccessor?: string;
  eventPropGetter?: string;
  slotPropGetter?: string;
}

BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
// let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k])

const getCalendarEventComponent = (contentFunction: (event: any) => any) => {
  class CalendarEventComponent extends React.Component<any> {

    closeToolTip = (e: any) => {
      const pop = (document as any).querySelectorAll(".ant-popover");
      
      if(pop) {
        pop.forEach((pp: any) => pp.classList.add("ant-popover-hidden"));

        setTimeout(() => {
          pop.forEach((pp: any) => pp.classList.add("ant-popover-hidden"));
        }, 400);
      }
    }

    render() {
      const event = this.props.event;
      // console.log(event);
      return (
        <Popover
          title={this.props.title}
          placement="leftTop"
          content={contentFunction(event)}
        >
          <div style={{ height: '100%' }} onMouseDown={this.closeToolTip}>{this.props.title}</div>
        </Popover>
      );
    }
  }

  return CalendarEventComponent;
};

@observer
class CalendarComponent extends React.Component<RendererComponentProps<CalendarConfig> & ContextObserver<any>> {
  lastEvents: any;
  lastResTime: number;

  getCollection(): ResourceCollection | undefined {
    return this.props.context.resources[this.props.config.resource];
  }

  // deselectEvent = () => {
  //   this.setState({ selectedEvent: undefined });
  // };

  // getDetailContent() {
  //   const { config, context } = this.props;
  //   const { selectedEvent } = this.state;

  //   if (!selectedEvent) {
  //     return null;
  //   }

  //   const ctx = { calendarEvent: selectedEvent, calendar: this, ...context };

  //   return config.detailContent ? (
  //     <Broadcast channel="context" value={ctx}>
  //       <Renderer content={config.detailContent} context={ctx} />
  //     </Broadcast>
  //   ) : null;
  // }

  render() {
    const { config, context } = this.props;
    const resource = this.getCollection();
    
    let events = resource && resource.data ? toJS(resource.data.items) : [];

    if(resource) {
      const rt = resource.times;
      const last = rt[rt.length-1];
      const find = rt.find((f: any) => f.start < last.start && f.end > last.end)

      if(find && last) {
        //pokud se najde takovy zaznam, co zacal driv, ale skoncil po poslednim, zahodi se
        events = last.res.items || [];
      }
    }

    const startAccessor = config.startAccessor || 'start';
    const endAccessor = config.endAccessor || 'end';
    const titleAccessor = config.titleAccessor || 'title';

    const test = (event: any): any => {
      const ctx = { ...context, event };
      return (
        <Broadcast channel="context" value={ctx}>
          <Renderer content={config.tooltipContent} />
        </Broadcast>
      );
      // return (
      //   <div>
      //     <div>{event.nsPobNazev}</div>
      //     <div>{event.nsOrgNazev}</div>
      //     <div>{event.nsCinNazev}</div>
      //     <div>{event.nsZakMesto}</div>
      //     <div>{moment(event.dRvPlanFr).format('DD/MM/YYYY HH:mm')} –</div>
      //     <div>{moment(event.dRvPlanTo).format('DD/MM/YYYY HH:mm')}</div>
      //   </div>
      // );
    };

    const components = {
      event: getCalendarEventComponent(test)
    };

    const messages = {
      allDay: translate('calendar-all-day'),
      previous: translate('calendar-previous'),
      next: translate('calendar-next'),
      today: translate('calendar-today'),
      month: translate('calendar-month'),
      week: translate('calendar-week'),
      day: translate('calendar-day'),
      agenda: translate('calendar-agenda'),
      date: translate('calendar-date'),
      time: translate('calendar-time'),
      event: translate('calendar-event'),
      showMore: () => translate('calendar-show-more')
    };

    const eventPropGetter = config.eventPropGetter;
    const slotPropGetter = config.slotPropGetter;
    // const { redirect } = context;

/*
       <AntdDatePicker 
          format={"D.M.YY"} 
          onChange={(date: any) => redirect(".", { calendarDate: date.toDate() })}
        />
*/

    return (
      <div style={{ height: config.height || '500px' }}>

        <DragAndDropCalendar
          events={events}
          startAccessor={(obj: any) => {
            return moment(obj[startAccessor]).toDate();
          }}
          endAccessor={(obj: any) => {
            return moment(obj[endAccessor]).toDate();
          }}
          titleAccessor={(obj: any) => {
            const ctx = { ...context, event: obj };
            return <div>{renderTemplate(titleAccessor, ctx)}</div>;
          }}
          step={60}
          showMultiDayTimes={true}
          defaultDate={new Date()}
          selectable={true}
          date={config.date ? evaluate(config.date, context) : undefined}
          className="kalendar zakazek"
          components={components}
          messages={messages}
          formats={{
            eventTimeRangeFormat: () => {
              return '';
            }
            // dayRangeHeaderFormat: () => {
            //   return 'aa';
            // }
          }}
          onNavigate={
            config.onNavigate
              ? (date: any) => {
                  if (config.onNavigate) {
                    evaluate(config.onNavigate, { date, ...context });
                  }
                }
              : undefined
          }
          view={config.view ? evaluate(config.view, context) : undefined}
          onView={(view: string) => {
            if (config.onView) {
              evaluate(config.onView, { view, ...context });
            }
          }}
          onSelectSlot={(slot: any) => {
            if (config.onSelectSlot) {
              evaluate(config.onSelectSlot, { slot, ...context });
            }
          }}
          onSelectEvent={(event: any) => {
            if (config.onSelectEvent) {
              evaluate(config.onSelectEvent, { event, ...context });
            }
          }}
          onEventDrop={async (e: any) => {
            const ctx = { event: e, ...context };

            if (config.onEventDrop) {
              evaluate(config.onEventDrop, ctx);
            } else {
              let values = {};
              values[startAccessor] = moment(e.start).toISOString();
              values[endAccessor] = moment(e.end).toISOString();
              if (resource) {
                await resource.update(e.event.id, values);
                await resource.reload();
              }
            }
          }}
          eventPropGetter={
            eventPropGetter
              ? (event: any, start: Date, end: Date, isSelected: boolean) => {
                  const res = evaluate(eventPropGetter, {
                    event,
                    ...context
                  });
                  return res;
                }
              : undefined
          }
          slotPropGetter={
            slotPropGetter
              ? (event: any, start: Date, end: Date, isSelected: boolean) => {
                  const res = evaluate(slotPropGetter, {
                    event,
                    ...context
                  });
                  return res;
                }
              : undefined
          }
          
        />
      </div>
    );
  }
}

export class CalendarComp extends React.Component<
  RendererComponentProps<CalendarConfig>
> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <CalendarComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}

export const Calendar = withDragDropContext(CalendarComp);


// WEBPACK FOOTER //
// ./src/modules/calendar/components/calendar/Calendar.tsx